import { pushAlert } from '@/services/messages/alertService';

export default {
  install(Vue) {
    Object.defineProperties(Vue.prototype, {
      $pushAlert: {
        get: () => pushAlert,
      },
    });
  },
};
